module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/14xCpvE/tc-custom/9781439677742.jpg?1733101990334",
      "alt": "This image is the cover for the book Celebrating Southern Appalachian Food, American Palate"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Celebrating Southern Appalachian Food, American Palate\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("High country cooking fit to grace any table. Southern Appalachia has a rich culinary tradition. Generations of passed down recipes offer glimpses into a culture that has long been defined, in considerable measure, by its food. Take a journey of pure delight through this highland homeland with stories of celebrations, Sunday dinners and ordinary suppers. The narrative material and scores of recipes offered here share a deep love of place and a devotion to this distinctive cuisine. The end result is a tempting invitation, in the vernacular of the region, to \"pull up a chair and take nourishment.\" Authors Jim Casada and Tipper Pressley, both natives of the region, are seasoned veterans in sharing the culinary delights of the southern highlands.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jim Casada, Tipper Pressley\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Jim Casada is a former university professor who now is a full-time freelance writer. He is the author or editor of dozens of books and has published thousands of articles in regional and national magazines. He writes a regular cooking column for Smoky Mountain Living magazine. Tipper Pressley has been writing about all things Appalachia since 2008 on the popular blog Blind Pig and The Acorn . Her YouTube channel, Celebrating Appalachia, further celebrates and preserves Appalachian culture. Tipper often teaches Appalachian cooking classes at locales throughout the region.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0